import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';
import { Badge } from '../components/ui.jsx';

const ICONS = { payroll: '💵', attendance: '📅', incident: '⚠️', advance: '💰', contract: '📄' };
const PRIORITY_BADGE = { high: 'high', medium: 'medium', low: 'low' };

export default function Notifications() {
  const navigate = useNavigate();
  const [items, setItems] = useState(null);

  useEffect(() => { api('/notifications').then(setItems).catch(() => setItems([])); }, []);

  if (!items) return <div className="empty-state"><p>Loading notifications…</p></div>;

  return (
    <div className="notif-list">
      {items.map((n, i) => (
        <div key={i} className="notif-item" onClick={() => n.link && navigate(n.link)}>
          <div className={`notif-icon ${n.type}`}>{ICONS[n.type] ?? '🔔'}</div>
          <div className="notif-body">
            <div className="notif-msg">{n.message}</div>
            <div className="notif-time">
              {new Date(n.date).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
            </div>
          </div>
          <Badge kind={PRIORITY_BADGE[n.priority]}>{n.priority}</Badge>
        </div>
      ))}
      {items.length === 0 && (
        <div className="empty-state"><p>All clear — nothing needs your attention right now. ✨</p></div>
      )}
    </div>
  );
}
